import { ReactComponent as Trash } from 'assets/icons/trash16.svg'
import Styles from './TrashIcon.module.scss'

export const TrashIcon = () => (
  <div className={Styles.iconContainer}>
    <Trash className={Styles.icon} />
  </div>
)
